export default "__VITE_ASSET__DPdciE8a__"